import api from './api'

export const badgeService = {
  // Get all available badges
  getAll: async () => {
    const response = await api.get('/badges')
    return response.data
  },

  // Get user's earned badges
  getMyBadges: async () => {
    const response = await api.get('/badges/my-badges')
    return response.data
  },

  // Get user's badge progress
  getProgress: async () => {
    const response = await api.get('/badges/progress')
    return response.data
  },
}
